import { render, staticRenderFns } from "./DialogPackageInfo.vue?vue&type=template&id=60101ac4"
import script from "./DialogPackageInfo.vue?vue&type=script&lang=js"
export * from "./DialogPackageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports